import { LocalStorageKey } from '@app/shared/interfaces';
import { Channel, ChannelLabelMap } from '@app/shared/models/channel';
import { capitalize } from '@utils';

export function countWords(str): number {
  const arr = str.split(' ');
  return arr.filter((word) => word !== '').length;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getBoolean(value: any) {
  switch (value) {
    case true:
    case 'true':
    case 1:
    case '1':
    case 'on':
    case 'yes':
      return true;
    default:
      return false;
  }
}

export const retrieveUserFromLocalStorage = () => {
  const userObj = JSON.parse(localStorage.getItem(LocalStorageKey.user) ?? '{}');
  return userObj ? userObj : {};
};

export function parseJwt(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
}

export function toPlatformLabel(value: string): string {
  if (!value?.length) {
    return value;
  }

  return ChannelLabelMap[value as Channel] ?? capitalize(value);
}
